// extracted by mini-css-extract-plugin
module.exports = {"container":"BigQuote_container__tolsV","longText":"BigQuote_longText__hRqbw","longWord":"BigQuote_longWord__0ZvM_","quotation":"BigQuote_quotation__wi8Vp"};